import { useState } from "react";
import { techReports } from "@/mocks/reports";

export default function TechReportAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleSection = (idx: number) => {
    const willOpen = openIndex !== idx;

    if (willOpen) {
      const scrollY = window.scrollY;
      setOpenIndex(idx);
      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollY, behavior: "auto" });
      });
    } else {
      setOpenIndex(null);
    }
  };

  return (
    <section className="py-12 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
          技術レポート
        </h2>
        <p className="text-center text-foreground-600 text-sm md:text-base mb-10 -mt-4">
          接触抵抗評価やガス腐食試験に関する技術情報を発信しています。各項目をクリックすると詳細が表示されます。
        </p>

        <div className="space-y-3">
          {techReports.map((report, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={report.id}
                className="rounded-lg overflow-hidden border border-background-200/70 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => toggleSection(idx)}
                  className="w-full flex items-center gap-4 px-5 py-4 text-left bg-background-100 hover:bg-background-200/60 transition-colors cursor-pointer group"
                >
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium">
                        {report.category}
                      </span>
                      {report.author && (
                        <span className="text-xs text-foreground-500">{report.author}</span>
                      )}
                    </div>
                    <p className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-foreground-950 transition-colors">
                      {report.title}
                    </p>
                  </div>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 md:px-8 py-5 md:py-6 bg-background-50 border-t border-background-200/70">
                      <div className="text-foreground-700 text-sm leading-relaxed mb-4 pb-4 border-b border-background-200/50">
                        {report.summary}
                      </div>
                      <div
                        className="report-content text-foreground-800 text-sm md:text-base leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: report.contentHtml }}
                      />
                      {report.pdfUrl && (
                        <div className="mt-6 pt-4 border-t border-background-200/50">
                          <a
                            href={report.pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                          >
                            <i className="ri-file-pdf-line" />
                            <span>PDF報告書をダウンロード</span>
                            <i className="ri-arrow-right-up-line text-xs" />
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}